export function isPreSale(preSaleDate: string | null) {
  return preSaleDate ? new Date(preSaleDate) > new Date() : false
}
